import { IconV2 } from '@abtasty/design-system';
import type { TFunction } from 'i18next';
import { FC, ReactFragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './DetailsTable.module.scss';
import { getTargetingLabel } from '@src/application/modules/tag/Campaigns/helpers';

export const DetailsTable: FC = ({ children }) => (
  <table className={styles.detailsTable}>
    <tbody>{children}</tbody>
  </table>
);

export function DetailsSection<T extends Record<string, any>>({
  title,
  array,
  children,
}: {
  title: string;

  array?: T[];
  children?: (value: T, index?: number, array?: T[]) => ReactFragment;
}) {
  const hasChildren = array && array.length > 0 && children;
  return hasChildren ? (
    <>
      {array.map((e, index) => (
        <tr key={index}>
          <td className={`${styles.section} ${styles['p-0']}`}>{index === 0 && title}</td>
          {children(e, index, array)}
        </tr>
      ))}
    </>
  ) : (
    <tr>
      <td className={styles.section}>{title}</td>
      <td className={styles.condition} colSpan={3} />
    </tr>
  );
}

export const Td = ({ children }: { children: ReactNode }) => {
  return <td className={styles.section}>{children}</td>;
};

const StatusIcon: FC<{ success: boolean }> = ({ success }) =>
  success ? (
    <IconV2 aria-label="status accepted" icon="check" color="green" />
  ) : (
    <IconV2 aria-label="status rejected" icon="close" color="red" />
  );
export const TableCellStatus: FC<{ success: boolean }> = ({ success }) => (
  <td className={styles.status}>
    <StatusIcon success={success} />
  </td>
);

export const TableCellCondition = ({
  colSpan,
  children,
  className,
}: {
  colSpan?: number;
  className?: string;
  children?: ReactNode;
}) => (
  <td className={`${styles.condition} ${className}`} colSpan={colSpan}>
    {children}
  </td>
);

export const TableCellValue: FC<{ success: boolean; value?: string; triggerName?: string }> = ({
  success,
  value,
  triggerName,
}) => {
  const { t } = useTranslation();

  return (
    <td className={styles.value}>
      {!success && (
        <span className={styles.value}>
          {t('{{text}}: {{value}}', { value, text: getTableCellValueText(triggerName, t) || 'Current' })}
        </span>
      )}
    </td>
  );
};

const getTableCellValueText = (triggerName: string | undefined, t: TFunction): string => {
  let text = 'Current';
  if (triggerName === 'PREVIOUS_PAGE') {
    text = getTargetingLabel(triggerName, t);
  }
  return text;
};
